import type { Group } from '../types';

export const demoGroups: Group[] = [
  {
    id: 'demo-1', title: '한강 노을 5km 같이 뛰어요', description: '대화 가능한 페이스로 가볍게 달려요. 처음 오시는 분도 환영합니다!',
    hostName: '민준', hostInitial: '민', hostColor: '#dff36b', sports: ['running'], dateLabel: '오늘 · 오후 7:30', startsAt: '2026-08-11T19:30:00+09:00',
    area: '서울 영등포구', place: '여의나루역 2번 출구', level: '초급·중급', genderRule: '누구나', ageRule: '20~40대', maxMembers: 8, memberCount: 5, fee: 0
  },
  {
    id: 'demo-2', title: '퇴근 후 배드민턴 복식', description: '코트는 예약했어요. 라켓과 셔틀콕 챙겨오세요.',
    hostName: '서연', hostInitial: '서', hostColor: '#ffb59f', sports: ['badminton'], dateLabel: '내일 · 오후 8:00', startsAt: '2026-08-12T20:00:00+09:00',
    area: '서울 마포구', place: '마포구민체육센터', level: '중급', genderRule: '누구나', ageRule: '나이 무관', maxMembers: 4, memberCount: 3, fee: 6000
  },
  {
    id: 'demo-3', title: '주말에 뭐든 같이 움직여요', description: '러닝, 클라이밍, 탁구 중 날씨와 인원에 맞춰 골라요.',
    hostName: '지훈', hostInitial: '지', hostColor: '#a9d7ff', sports: ['running', 'climbing', 'table-tennis'], dateLabel: '토 · 오전 10:00', startsAt: '2026-08-15T10:00:00+09:00',
    area: '서울 성동구', place: '서울숲역 인근', level: '모든 수준', genderRule: '누구나', ageRule: '20~30대', maxMembers: 6, memberCount: 2, fee: 0
  },
  {
    id: 'demo-4', title: '파크골프 라운딩 동반 구해요', description: '천천히 즐기실 분 두 분 모십니다. 초보도 알려드려요.',
    hostName: '영숙', hostInitial: '영', hostColor: '#e7c6ff', sports: ['park-golf'], dateLabel: '일 · 오전 8:00', startsAt: '2026-08-16T08:00:00+09:00',
    area: '경기 고양시', place: '대화천 파크골프장', level: '초급', genderRule: '누구나', ageRule: '50대 이상', maxMembers: 4, memberCount: 2, fee: 3000
  },
  {
    id: 'demo-5', title: '스크린골프 18홀 한 게임', description: '명랑 골프! 실력보다는 매너 좋고 즐거운 분이면 됩니다.',
    hostName: '도윤', hostInitial: '도', hostColor: '#ffd98e', sports: ['screen-golf', 'golf'], dateLabel: '금 · 오후 7:00', startsAt: '2026-08-14T19:00:00+09:00',
    area: '서울 강남구', place: '선릉역 도보 3분', level: '모든 수준', genderRule: '누구나', ageRule: '30~50대', maxMembers: 4, memberCount: 1, fee: 25000
  },
  {
    id: 'demo-6', title: '초보 테니스 랠리 연습', description: '레슨 3개월 이상, 공 넘기면서 같이 감 잡아봐요.',
    hostName: '하은', hostInitial: '하', hostColor: '#b8f2d0', sports: ['tennis'], dateLabel: '토 · 오후 4:00', startsAt: '2026-08-15T16:00:00+09:00',
    area: '서울 송파구', place: '올림픽공원 테니스장', level: '초급', genderRule: '누구나', ageRule: '나이 무관', maxMembers: 4, memberCount: 3, fee: 8000
  }
];

export const areas = ['내 주변 5km', '서울 전체', '서울 강남구', '서울 송파구', '서울 마포구', '서울 성동구', '서울 영등포구', '경기 고양시', '경기 성남시', '경기 수원시', '인천', '부산', '대구', '대전', '광주', '울산', '세종', '제주'];
